// extracted by mini-css-extract-plugin
module.exports = {"text_dis":"discount_text_dis__17VCD"};